
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'backspaceKey': `⟵`,
'clearKey': `⎚ Clear`,
'deleteKey': `⌦ Entf`,
'downKey': `↓ Runter`,
'endKey': `⤓ Ende`,
'enterKey': `↩ Eingabe`,
'escapeKey': `⎋ Escape`,
'f10Key': `F10`,
'f11Key': `F11`,
'f12Key': `F12`,
'f13Key': `F13`,
'f14Key': `F14`,
'f15Key': `F15`,
'f16Key': `F16`,
'f17Key': `F17`,
'f18Key': `F18`,
'f19Key': `F19`,
'f1Key': `F1`,
'f2Key': `F2`,
'f3Key': `F3`,
'f4Key': `F5`,
'f5Key': `F6`,
'f6Key': ``,
'f7Key': `F7`,
'f8Key': `F8`,
'f9Key': `F9`,
'h64cd12550420f6f1': html`Generiere eine <code>LICENSE</code>-Datei`,
'homeKey': `⤒ Pos1`,
'keyCommand': `⌘ Command/Win`,
'keyControl': `^ Strg`,
'keyOption': `⌥ Option/Alt`,
'keyShift': `⇧ Umschalt`,
'leftKey': `← Links`,
'pagedownKey': `▼ Bild`,
'pageupKey': `▲ Bild`,
'rightKey': `→ Rechts`,
's00065e45db8c0441': `Siehe Entwickler-Werkzeuge für mehr Informationen`,
's001dd78415a91fa0': `Scroll-Rinne`,
's002fa7d1054ed082': `Border-Box`,
's006f872a5b7f5279': `Sangro`,
's01b16a926920908b': `Kasachisch`,
's01b56d233c6c5cac': `Abschnitts-Trennung`,
's01d32b35baa3b676': `Autor`,
's02106cc2ef0e7578': `Neuer Schnipsel...`,
's02ab1ea8e5100fc1': `Auswahl als bidirektionale Überschreibung markieren`,
's0312976fe9da5951': `Knopf`,
's03608a32f05eded2': `Kneif-Zoom`,
's036d35e03be98d22': `Mathe-Tiefe`,
's037b1dc850a89273': `Abwechselnd darunter`,
's0396202b716732ec': `Markiere die Auswahl als durchgestrichen`,
's03f49e598ffb11cc': `Polnisch`,
's0448f1059fa01720': `Speichere, teile oder drucke das Explorable. Bearbeite Informationen wie den Titel, die Sprache, oder die Lizenz.`,
's0458872c43beadef': `Zeile davor einfügen`,
's04c939a414fdab21': `Xitsonga`,
's050954cd4ae83304': `Wort-Abstand`,
's05e9759cfd99c48f': `Ausrichten`,
's063fa5a0a4903bf4': `Seitlich, Links-nach-rechts`,
's064339c229374050': `Encoding`,
's06634274f19b0572': `Auswahl anheften`,
's06743b24499f0035': `Anker-Mitte`,
's07808b0ca6da8fef': `Abgegrenzte Website`,
's07970793b21351fd': `Ruby-Basis-Container`,
's079cf7850d9327f0': `Schrift`,
's07aa10850d9ddcc7': `Formular`,
's07e6118e838b2e23': `Navigation`,
's0816468df86e4036': `Öffnet die Einstellungen`,
's082869038c117fe5': `Portugiesisch (Brasilien)`,
's086e6c267ade2609': `Sättigung`,
's08e12ade32ef8125': `Setswana`,
's08e6bd98452e6bb9': `Audio`,
's0978fb5ba3145996': `Liste einfügen (ungeordnet)`,
's09c3f1d21de14ae1': `Markiere die Auswahl als unterstrichen`,
's0a2d91c6720033e9': `Text-Abstand zuschneiden`,
's0a3ddcba94027d95': `Objekt-Einpassung`,
's0a6cb8d42cdb0c4a': `Esperanto`,
's0a799f583098cadf': `Navigation einfügen`,
's0a7db790db1fc45c': `Auswahl als Spanne markieren`,
's0b1271f50a77dc73': `Content-Box`,
's0b24d08ea349b455': `Alles, was du einfügen kannst. Vorn sind nicht interaktive Elemente wie Listen oder Bilder, es folgen interaktive Elemente, die Widgets genannt werden. Du kannst neue Widgets finden, indem du in die Suchleiste klickst.`,
's0bdca49248ba4820': `Tastenkürzel`,
's0befccf152b6c0a9': `Bildorientierung aus Metadaten`,
's0c11e479416c8421': `Tabellen-Unterschrift einfügen`,
's0c27336067c59611': `Scroll-Innenabstand`,
's0c4593d81f147042': `Grundlinie`,
's0c4b2e98d4ab7f5a': `App-Befehle`,
's0c883713b83616a8': `Speichere das aktive Dokument`,
's0ca5c0460199cba1': `Abkürzung`,
's0cf10c4f40588f8d': `Tabellen-Unterschrift`,
's0d86afa3c6a1e28b': `Flex-Richtung`,
's0dad143dff0079fc': `Malayalam`,
's0db05bd7ba6fff96': `Dein Explorable-Dokument. Du kannst Text schreiben, kopieren/einfügen, bearbeiten, usw.`,
's0dc452999c129e15': `Live-Reloading aktivieren`,
's0de0febab8a4beaf': `Fehler beim Lesen dieses Packages`,
's0e44968489e076a8': `Chinesisch`,
's0e4862e87c7d53ce': `Die Auswahl als Zitat markieren`,
's0e6ea8870dbddab2': `Dokument-Befehle`,
's0ee28503778e4c0c': `Letzte Grundlinie`,
's0ef01c03299bbb83': `Dekoration`,
's0f17f32919661cff': `Mongolisch`,
's0f350bc4e538e3ea': `Wörter`,
's105a06836c40fcb4': `Setze die Filter, Farben und Überblendung ausgewählter Elemente`,
's106b274b5af798e5': `Sätze`,
's1082e1649793dca9': `Auswahl als definierten Begriff markieren`,
's10f3845975a0351e': `Metadaten bearbeiten`,
's1125d159f7e64df5': `Anzeige`,
's11326fd2590f4e5e': `Standard`,
's1155ec07a221e739': `Scrollbar`,
's1173bf7a3e0b74c9': `Minimum (y)`,
's1177237a3e0e548c': `Minimum (x)`,
's1219d97b49650c05': `Sichtbarkeit`,
's123bea44f38abccf': `Objekt einfügen`,
's1245e2cb9f20197e': `Anordnen`,
's12946ec1b850962c': `Spalte danach einfügen`,
's1351209ef74ee729': `Alle Spalten abdecken`,
's13c60cb409e8cb6f': `Mittig anordnen`,
's13ebd619c8a06a6d': `Grid-Auto-Zeilen`,
's13ef8ca26ca8861b': `Element ausschneiden`,
's151bc2eea7a032a4': `-unverändert-`,
's153bc3c3aa39587b': `Tabellen-Kopfabschnitt`,
's156647179b21d351': `Tabellen-Körper einfügen`,
's158b6ec6b1fffcb2': `Danach umbrechen`,
's15d0c0657c1ee08c': `API-Schlüssel`,
's1626a7e10a9f9dcc': `Legt die Schriftart der Auswahl fest`,
's1637c7d1a30629e2': `Border Box`,
's1641ab440bf4daa4': `Dieses Paket aktualisieren`,
's166bd56d19670a72': `Zoom`,
's1696c76a23c0834e': `Fortgeschritten: Zeige Packages mit Versionen wie 0.x.x im Package-Manager`,
's16b9446e3a70e1f4': `Attribute`,
's16f205466761e583': `Keine opt. Schriftgröße`,
's16f2f1c2c516d307': `Öffne ein Dokument`,
's1749014f3f87fa6a': `Strecken`,
's17597a8bb4810524': `Lizenz`,
's17bfaaa4e7528bc7': `Baschkirisch`,
's17fb3f4805f4f4b9': `Feld löschen`,
's181ef198cf83ec3a': `Bihari`,
's1857db526dc4dcdd': `Paket erstellen`,
's18d5c44aae3dc82a': `Online beim bearb.`,
's1988d71ef8060edf': `Tabellen-Zeile einfügen`,
's19abee1277c9bca2': `Samoanisch`,
's19daf2f26c19543d': `Umrandung`,
's1a1acc902e6668e0': `Fortgeschrittene Text-Optionen zeigen`,
's1a5230a71d9285c1': `Aufzeichnen`,
's1aa1cb63ad44bc6f': `Spalten-Lücke`,
's1af8b67d1c85c811': `Abstand dazwischen`,
's1b4a36fce2456660': `Schriftart`,
's1c246045629b0016': `Auswahl als Löschung markieren`,
's1c3fc313a9184670': `Öffentlicher Link`,
's1c65f5004a07dcfa': `Schottisch-Gälisch`,
's1c690963f1e2df00': `Plattform-spezifischer Look`,
's1ca22ce85e074da5': `Pragma`,
's1d10d2058d8ca8dd': `Möchtest du eine kurze Einführung?`,
's1d19244f549ec535': `Bildung`,
's1d5c7b28e8b50d6d': `Meisterbildung`,
's1db591f5a54dbfd3': `Content Box`,
's1dbb9f50e16c92a3': `Eckradius`,
's1dfb744260fb3a01': `Bidirektionale Gruppierung`,
's1e9c2c654732cc5f': `Weißrussisch`,
's1eaccbf2d6af8ab5': `Information`,
's1efbfc3937d565bd': `Hintergrund`,
's1f2b49c1bca2035d': `Katalanisch`,
's1f74bdf32b51a5fc': `Hintergrundbild`,
's1f7698c061c208c9': `Öffnen`,
's1f8e59d0624842ff': `Kannada`,
's1feab14d837eadb0': `Guaraní`,
's20deffeecf2699fb': `Korsisch`,
's21d61916eb8d137d': `Tabellen-Körper`,
's21d723a1dbcd89c8': `Javanisch`,
's21f8a2eaf5a70749': `Beschriftung einfügen`,
's2206c42e5b835e6e': `Die Auswahl als Abkürzung markieren`,
's22a2348c46a912a0': `Abschnitt einfügen`,
's233ae776268cd44b': `Wirtschaftswiss.`,
's236ed7ba747099b0': `Schrift-Stärke`,
's2492f5fb1b05b45e': `Text`,
's24949d7adbb5a098': `Toolbox`,
's252a52330d32b900': `Metadaten`,
's2540844a4bc4d9ba': `Namensnennung verlangen?`,
's255857544a9d5ec0': `Rücksetzen`,
's255c77900f2b5e0f': `Farbschema`,
's256ab831a48c941c': `Entferne sämtliche Text-Formatierung von der Auswahl`,
's2591806d7b222591': `Änderungen zurücksetzen`,
's25e1a07e454c2c11': `Grid`,
's262abbaf1d05f009': `Weiches Licht`,
's266935f2447fcd98': `Links darüber`,
's268ecd1cef45a9a8': `Bestätigen?`,
's2692bc028fed91f1': `⇪ Feststell`,
's27056379e0acfdb0': `Erhellung`,
's27076e66c5d483ba': `Vertikal anordnen`,
's2712dc5641a33226': `Package-Registry-Konten sind für Entwickler gedacht und erlauben es dir, eine oder mehrere Registries zu verbinden.`,
's27cc88818cc46ff6': `Stabil`,
's281d957112b10f12': `Den HTML-Text des Dokuments direkt bearbeiten`,
's28b6246ce616a548': `Tabellen-Spaltengruppe einfügen`,
's29a1c26521879b9f': `Verkleinern`,
's29acfd2778e8c377': `Fortgeschrittene Text-Optionen verstecken`,
's29b24c06315e9343': `Eingabefeld einfügen`,
's29eb103449472e3b': `Überschrift einfügen (Ebene 3)`,
's29ee7434494a0dfe': `Überschrift einfügen (Ebene 2)`,
's29f21c34494d614d': `Überschrift einfügen (Ebene 1)`,
's29fbfc3449557f72': `Überschrift einfügen (Ebene 6)`,
's29ff743449588131': `Überschrift einfügen (Ebene 5)`,
's2a031834495bcdb4': `Überschrift einfügen (Ebene 1)`,
's2a75c946ef4dcab7': `Sonstiges`,
's2b2ae20d26f78ac2': `Block`,
's2b8f50c64be440f7': str`${0} auswählen...`,
's2ba5f4d8f3bd7c57': `Ordnung`,
's2bad2d24def4aa0b': `Zeilenumbruch (CJK-Spr.)`,
's2ceb11be2290bb1b': `Abbrechen`,
's2ced8e8fafb499f6': `Element löschen`,
's2d986d31f8d67357': `Formularbereich einfügen`,
's2d995a37cf5e4995': `NoScript`,
's2de969afacdaa7a6': `Form`,
's2df075aface0dab8': `Teilen`,
's2e192b19ed15fcf6': `Seite`,
's2e39b99cf23606fa': `Setze das Layout ausgewählter Elemente`,
's2e4818861000b13f': `Layout`,
's2e66bf8b833858f3': `Uigurisch`,
's2e969a451b4955d1': `Marathi`,
's2eda5288a65bca1d': `Überhang (y)`,
's2edd6688a65e21f0': `Überhang (x)`,
's2f0bcdffc92a786b': `Rechts schwebend`,
's2f2044f2431a32d5': `Überschrift`,
's2f4d4bfbc466d91f': `Albanisch`,
's2f8da2cb5f236588': `Der Name des Packages. Muss Scoped sein, z.B. \`@org/pkg\`.`,
's30cce87854901922': `Vorschule`,
's3124653c272f054c': `Spaltentrenner-Farbe`,
's314a4f7685c8e824': `Immer`,
's31c06e226322f065': `Waisen vermeiden`,
's323dcde72b850272': `Öffentlich zugänglich`,
's32911e52ee8ac745': `Slot einfügen`,
's337a1e9022a8d19f': `Tabelle`,
's33c1450d2822bb0f': `Abbildungsbeschriftung einfügen`,
's33c18d5a4cbffa2a': `Irisch`,
's33f85f24c0f5f008': `Speichern`,
's342b0cabfa672822': `Hilf dem Nutzer, das Widget zu finden`,
's3437e0d9899e7ae1': `Sende Telemetrie-Daten über deine WebWriter-Nutzung.`,
's344ea8f4939cdc98': `Farbe`,
's34dcda3b0f9d5a98': `URL umschalten`,
's34f724979a124c50': `Setze die Hintergrundfarbe des auswählten Texts`,
's355b21b89ce5d9c5': `Details`,
's35ae5f4e0fa2777b': `Spezial-Anordnung`,
's35aeaff1425bca9e': `WebWriter unterstützt diesen Datentypen nicht`,
's35c3125c7750681e': `Blockzitat`,
's3643189d1abbb7f4': `Code`,
's3649bacefe731bf6': `Toolbox umschalten`,
's365280e16a8ea32d': `Kopiert die Auswahl`,
's366991b9c9287765': `Rechts`,
's36a194e38d653a26': `Daten-Annotation`,
's36b3cefdcb897f15': `Perpektive`,
's372fae706048ce41': `Gerade-ungerade`,
's377e24af9628c37e': `Geordnete Liste`,
's37a8c35f6581da5f': `Kein Anker`,
's37fa3b9cd51c2dfd': `Legt die Schriftgröße der Auswahl fest`,
's380d17664bb69531': `Spalte davor einfügen`,
's3815184eb09f0dcf': `Mauszeiger`,
's382a2aa3984474dd': `Erstellen`,
's38980f98cb07ceb8': `Speichere das aktive Dokument als Kopie`,
's3914cb410fca44d4': `Importieren`,
's3a179f6db2972384': `Ruby-Position`,
's3a5ca02f282d247e': `Teilen...`,
's3ae67088bbefba98': `Pakete`,
's3b0ab4b52326316f': `Hell`,
's3b3ea038c5d3bb06': `Unterteilung`,
's3bdad99768e11911': `Explorable`,
's3cb47df8290fa94c': `Option einfügen`,
's3cf89cb47fdde7e9': `Link`,
's3d09398e555ee5f9': `Fortgeschrittene Optionen`,
's3d249bb480032121': `Liste`,
's3d3efd1e19bdcfb4': `Datum/Zeit-Annotation`,
's3d6a732c792ccb9e': `Ruby-Annotation`,
's3d93f9ea0c5a13fa': `Bild`,
's3d9548e211b958ce': `Überhänge überspringen`,
's3e092e9d1ee2c5bb': `Abgeschnitten`,
's3e78ddc9a48a608d': `Schön`,
's3eb6d1e6e79ed7c4': `Keine Dokumente gefunden`,
's3eca5a034978754b': `Löscht die Auswahl`,
's3f06e9abb6ebcb79': `Zeichen`,
's3f1e7a3f2b283d3b': `Margen`,
's3f299e83cbf52fba': `Zhuang`,
's3f43ef2eaa1ec486': `Gujarati`,
's3f7e097a9b2e6181': `Artikel einfügen`,
's3fd83566dd643d10': `Legende einfügen`,
's3fe72792941c18f9': `Text unten`,
's3ffcdc5db5e7d0c5': `Umgekehrt`,
's40e3826b7f74a3b5': `Schwenken (rechts)`,
's40f07d7859284a44': `Dominante Grundlinie`,
's4101ada154a1b958': `Mitte`,
's410c465a5993f82d': `Zeilenumbruchs-Gelegenheit`,
's41322d19c928c603': `Informationstech.`,
's417b90913e05bc17': `Vorschau`,
's418f2020fe996832': `Änderungen bestätigen`,
's41c724f0698148e9': `Die Auswahl als Tastenkürzel markieren`,
's41f65a763f8e44ab': `Tabellen-Kopfzeilen-Gruppe`,
's42721130228841b0': `Stroke-Box`,
's429bd646f1cf8bc6': `LLM-Accounts ermöglichen es, Grammatik-Korrektur für Texte zu nutzen.`,
's429dd933ba95549b': `Adressbereich einfügen`,
's42e470ef1d707a28': `Autoplay`,
's42ffdab1291fb3de': `Zeile danach einfügen`,
's430831017f3f0499': `Zerren (y)`,
's430bd5017f42511c': `Zerren (x)`,
's433ba70286202ceb': `Alle umbrechen`,
's441b20a8a50e36b4': `Makedonisch`,
's445b8acb9206db6e': `Verwerfen und abbrechen`,
's446a924922651ea0': `Text-Betonung`,
's44cdba92713de38e': `Grid-Bereich`,
's45518abd911471d0': `Kroatisch`,
's456a8d744313852a': `Abstand darum`,
's4634541f5056a546': `Abchasisch`,
's46d4abe6255cb9e1': `Kürzel neu zuweisen`,
's4730c232e7209c40': `Beide zuschneiden`,
's474f0eec369d02a4': `Ausgabe`,
's47a8f6dfb38b9701': `Telugu`,
's47e257ae643b5851': `Auswahl als Datum/Zeit-Annotation markieren`,
's47ebf3a8fb3b10c1': `Orientierung`,
's4802bb8eb52fbdeb': `Portal`,
's4802e47fe2e95134': `Option`,
's491d2919cd6ec3d9': `Farbton`,
's497838412cb455f2': `Text-Schatten`,
's4993444bfd3f3e5e': `Zusammenfallen`,
's49ad24935b14e3df': `Quechua`,
's49c560aecfeb8c29': `Maske`,
's49dd67aed00029ef': `Mathe`,
's49e763aed00877a8': `Hauptabschnitt`,
's4a894f57eba1cf1e': `Tastenkürzel`,
's4ac1ad6ecd6bd810': `Sonst. Bildung`,
's4ad6e9d3c2365c98': `Hartes Licht`,
's4b2c143acf931122': `Zeilenhöhe`,
's4b58c01e2578f5e4': `Legende`,
's4bbff4e008690da1': `Seiten vermeiden`,
's4c1535f316305a2a': `Inspiziert die Auswahl`,
's4c402ff5355fd310': `Bidirektionale Überschreibung`,
's4caed5b7a7e5d89b': `Englisch`,
's4cb38675a21b2c98': ``,
's4cc8391f172c0cdf': `Einführung beenden`,
's4d528b416ac8dee2': `Überschrifts-Gruppe einfügen`,
's4d546f6c87128d5b': `Erstes verteilen`,
's4e191bdb4700a6e9': `Überscrollen (x)`,
's4e1c7fdb470386ac': `Überscrollen (y)`,
's4e2562fe3990e621': `Fehler beim Verbinden`,
's4e361bf8eef3759a': `Wort-Trennung`,
's4ea0f21fc2a338a1': `Nach oben verschieben`,
's4eace13b3ed74187': `Nebenkommentar`,
's4efee5b48a4593cb': `Schleife`,
's4f26e7cb7c0a8318': `Vektorzeichnung`,
's4fd2e638aabb0bb3': `WebWriter unterstützt viele verschiedene Quellen. Einfach einen Link einfügen zu: `,
's4fda04cbc245e18b': `Alpha`,
's4ffac3fb33a2ee9b': `Thai`,
's5015a8fb33b98872': `Dünn`,
's50489ffb1bde152e': `Hinzufügung`,
's5068560b8d39663d': `Klickbare Zuordnung`,
's517acbf1f96324f9': `Stärke`,
's523eb9043213ff0d': `Kursiv`,
's52777d434baeed9b': `Fortschrittsanzeige einfügen`,
's52af5d7ac34c2163': `Tabellen-Zeile`,
's52e0bdc3ee304436': `Zähler einfügen`,
's531056f039febd39': `Auswahlfeld einfügen`,
's536695196d0b6dc3': `Färöisch`,
's542fcefa0bbaed86': `Öffnet oder schließt die Toolbox (nur für schmale Bildschirme, ansonsten immer sichtbar)`,
's5432ad3c84273229': `Abbildung`,
's543906d1db8b2283': `Bearbeite `,
's543c237e8c895ce8': `Bislama`,
's545ee1f373f249cf': `Kambodschanisch`,
's54897f2764b0e4d0': `Dieses Paket installieren`,
's54cbfaf2a8da7818': `Paschtu`,
's550839f3e4e205bb': `Auswahl als besonders wichtig markieren`,
's55905c735052d295': `Inhaltlicher Trenner`,
's5590dbf7e425789d': `Beschriftung`,
's5623aa2f83b05c76': `Tibetanisch`,
's564d1648b1ceee9f': `Aktuell`,
's565cd5ffb0158c46': `Region vermeiden`,
's571a4f19e2f140c7': `Schwenken (x)`,
's571db319e2f4208a': `Schwenken (y)`,
's575e795c45e2d97e': `Zurück`,
's5787c6d5b3b5541a': `Ausschnitt`,
's579c69f419b6caef': `Glatt`,
's587ac858dd80f6fa': `Tiefgestellt`,
's58bec0ecd4f3ccd4': `Streng`,
's59404f5593c32fdc': `Zeichen-Kerning`,
's5941292bb77281ab': `Norwegisches Bokmål`,
's599dcd2472c75c19': `Absatz`,
's59b20e8af32606ed': `Afar`,
's5a1a0898baf20675': `Auswahl als Daten-Annotation markieren`,
's5a356677b61a6b7e': `Moldawisch`,
's5b474b5c0ac0c7c4': `Tabellen-Spalten-Gruppe`,
's5b517ac216f9ee62': `Seitlich`,
's5b8cc9bb61ddce15': `Absatz einfügen`,
's5bba2ac2e53bd1fd': `Kirgiesisch`,
's5be80ad6b8301710': `Inline-Start`,
's5c1ecf88259b79f9': `Präsentation`,
's5c2a1a52c0389c30': `Ingenieurswiss.`,
's5c63af7695445fcf': `Text-Stil`,
's5d18ca4c3111be6f': `Tabellen-Kopfabschnitt einfügen`,
's5d87c1e588f48d90': `Übung`,
's5d929ff1619ac0c9': `Suchbereich`,
's5da52af9b083c29a': `Modell`,
's5dc77784260a7236': `auto`,
's5e27738a2e8eb763': `Anmelden`,
's5e2cba97c0d971bd': `Pakete neu laden`,
's5e53415a6d5719ad': `Sozialwiss.`,
's5e6a7a0c30d2a270': `Nicht überschneiden (auto)`,
's5e9e8e4d21bafedc': `Lebensmittelprod.`,
's5ed03bb1f3a15949': `Abbildung`,
's5f43af3669b1e098': `Quelle`,
's5feaf7fd7ee567c8': `Wort umbrechen`,
's600fd23c9ce971e8': `Drucke das aktive Dokument`,
's602bbd28dae2c60f': `Selbst-Start`,
's60ff598dfcf2c773': `Rechts darunter`,
's61053f0e3ebbd272': `Normal`,
's613c6ff83883c04f': `Tabellen-Spalte`,
's6196153c4b0c1ea0': `Installieren`,
's61c017f6d5c303af': `Friesisch`,
's61ded17ca3f48c82': `Unterstreichungs-Abstand`,
's61eacb19db252f5e': `URL`,
's621ad19d35ba7742': `Auswahl kopieren`,
's624e31cd4f1b89d4': `Weiches Scrollen`,
's626daf42b1ab7df7': `Links anordnen`,
's6280bf993915c57a': `Scroll-Margen`,
's62b857f5b6693742': `Inupiak`,
's63d894b1ddb06289': `Beschreibung`,
's63dfc5b1c1c27849': `Jiddisch`,
's63e03c70f67ebf9c': `Kontext`,
's63e71d20d1eaca93': `Deutsch`,
's640bc7710d0143ce': `Wiederhole die letzte rückgängig gemacht Änderung im aktiven Dokument`,
's64dc1fc7e3db45c9': `Erstelle ein neues Dokument`,
's65ac276544ba33cd': `SVG-Datei`,
's66765c420ee578e4': `Gleichmäßig verteilen`,
's669b18c6d2d9c95b': `Keine`,
's6747dbf4ad6063ba': `Selbst-Ende`,
's6787497df07fa97e': `Kann Stopps überscrollen`,
's67c2b60a506a09e4': `Weiterführ. Bild.`,
's680bd4d926cd5a84': `3D erhalten`,
's6827930ef1aeaf99': `Base URL`,
's684a16f3c711394d': `Rechts darüber`,
's687e27f036a71b32': `Isolieren`,
's68b87d7b61052dc3': `Tabellen-Zeile`,
's68e0e3a2bab7ce3e': `Vermeiden`,
's690da6b432987c6f': `Änderungen am aktuellen Dokument automatisch sichern. Änderungen werden wiederhergestellt, wenn WebWriter neu geladen wird.`,
's69311c4e25074fb3': `Sekundarstufe II`,
's697400b541fbc3cd': `Darunter`,
's6988ab5d47593a26': `Die aktuelle Version von WebWriter ist installiert.`,
's69a49786a8009f43': `Pakete finden...`,
's69b12144dbb6544d': `Laotisch`,
's69d88ef4b2618980': `Abdecken`,
's69fbbdb8ad2a084a': `Verdunkelung`,
's6a31eff1ec4f71ad': `Rückseite verstecken (3D)`,
's6ac62e1c8c66f3bb': `Kompakte Hochst.`,
's6b585ba37cdb8260': `Erben`,
's6b61f8abf89586be': `Hebräisch`,
's6bd7a02fdf93e653': `Inhalt anordnen`,
's6cfc66b824ea05ba': `Scharfe Kanten`,
's6d02dc19e21eb49c': `Oben`,
's6d1df519e235a6cf': `Akan`,
's6d60d595cb5070da': `Vietnamesisch`,
's6d8b3b8047ed378d': `Mix-Blend-Modus`,
's6d8c02aee480af7a': `Menü`,
's6dadeaaee49d6d18': `Meta`,
's6dfb502188a8c7c2': `Style einfügen`,
's6e288a119281f4c2': `Text-Rendering`,
's6e4c20c6debcd5ca': `Spezial-Ausrichtung`,
's6f84199e62584905': `Vorformatierter Text`,
's6fb3053e7244d326': `Andere Felder`,
's70178e04a3b691b6': `Einstellungen öffnen`,
's7031ca562378bde6': `Geometrische Präzision`,
's7060970b5ed20a58': `Interaktivität`,
's7136449045eff28c': `Tamilisch`,
's71940c32987f675f': `WebWriter Cloud`,
's71a0549fd71219c9': `Zeige instabile Packages`,
's71dec51005acc1e4': `Zeile dicht`,
's72f2a02e2a5a4ee3': `Medien`,
's730182ad28374cda': `Objekt`,
's731678e227a20559': `Dieses Gerät`,
's736904f276fbd441': `Naturwiss.`,
's739544d0c858c633': str`Oder ${0} hier ablegen`,
's73cb20c838e761e1': `Auswahl ausschneiden`,
's7417792bbe720149': `Wiederholen`,
's741fae02b3dd24f3': `Verpixelt`,
's743f778233e42a3f': `Seitennotiz einfügen`,
's744d993d03f29851': `Schirm`,
's748c0074eff45884': `Manipulation`,
's74aa0039a87141e2': `Ellipse`,
's74b9781bacfcc87c': `Panjabi`,
's74cd20a7aece9b91': `Fill-Box`,
's75109f5307578a61': `Willkommen bei WebWriter`,
's75a27f43413e02c5': `Französisch`,
's75d83fc3f0cfab40': `Kopfzeile`,
's762e5704cc84089d': `Setze andere Stil-Optionen der ausgewählten Elemente`,
's77318393dfdb0775': `Zeile entfernen`,
's77e594ddcc10c774': `Kommerzielle Nutzung erlauben?`,
's782eac2b3e80323d': `Auswahl als betont markieren`,
's782f286a79cca35d': `Relativ`,
's78673a3539cb1915': `Oben links`,
's78789724e789221c': `Größe`,
's789ff24c8f03f1a4': `Zeichenabstand`,
's7995733bf97c01cc': `Serbokroatisch`,
's7a99528e7b64635a': `Okzitanisch`,
's7aaf0c06e69600f1': `Fehler bei `,
's7ae49e142487766c': `In Community zugänglich`,
's7af555180b30a947': `Öffne die Entwickler-Werkzeuge`,
's7b4ba250601b8667': `Schablone einfügen`,
's7b560d8693ed8f42': `Stehend`,
's7b9994904c4f5b54': `Tadschikisch`,
's7bdf0fd5b014d36c': `Besondere Wichtigkeit`,
's7beb1e77e82363eb': `Mache die letzte Änderung im aktiven Dokument rückgängig`,
's7c61118554a0ec36': `Maximum (x)`,
's7c95876637f6a9d7': `Filter`,
's7cb4e55c59663b1c': `Firma`,
's7cfe12cd14df9950': `Abmelden`,
's7d27db3c9639c6dd': `Abwechselnd`,
's7d8103f6f06f83d6': `Innenabstand`,
's7d864465dddbb50d': `Skalieren erlauben`,
's7de0e28d6c309a4e': `Berührungs-Gesten erlauben`,
's7dea785045c3cc74': `Neue Tastenkombination drücken...`,
's7e0b179d4d1414eb': `Link eingeben`,
's7e6570f2f1ae320f': `Schrift-Typen generieren`,
's7ecb1f29332293e5': `Anordnungs-Grundlinie`,
's7ed13ccddb1bf3c3': `Überlagerung`,
's7edbe0b213199995': `Bachelor`,
's7ede1c55e35ce9d6': `Simulation`,
's7f09197a4814079b': `Setze die Interaktivitäts-Optionen ausgewählter Elemente`,
's7f326a142e856656': `Style`,
's7fcb35d23be1e643': `Formularbereich`,
's80570196a9ce6d11': `Telemetrie aktivieren`,
's806f84eb0ace116e': `Sehe deine aktuelle Auswahl und verändere sie. Kopieren, Ausschneiden, Einfügen, Anpinnen, oder Layout-Änderungen sind möglich. Bietet je nach Auswahl unterschiedliche Optionen, z.B. Formatierung für Text.`,
's80a42b81c52d4d8f': `Einfügemarken-Farbe`,
's80b71fc6f43c5ce1': `Locker`,
's812cbda653daaeba': `Diese Funktion ist noch nicht umgesetzt`,
's814d528c8af55807': `Definitionslisten-Element`,
's81c3d8809658b951': `Kashmiri`,
's81cf65c5a46dea08': `Kinyarwanda`,
's81ecf2d4386b8e84': `Weiter`,
's8247d32213e35f24': `Hauptabschnitt einfügen`,
's82665b2ffabc9c0a': `Website`,
's828b1ecea8715884': `Schwenken (links)`,
's833bd0422a7ef95d': `Tab-Größe`,
's83420ad7b6a14db5': `Entwickler-Werkzeuge umschalten`,
's83c15613b6f6f3c8': `Nur online`,
's83cd32b685ccc9b7': `Steuerung`,
's83f26d02dd7aa681': `Sichtbar`,
's840fa49e8989c028': `Position/Form`,
's844a76d1843ceb3c': `Zurücksetzen zu Standard`,
's84e4e8ae645b82ac': `Oben rechts (y)`,
's84e9c7f8785ca60b': `Formular einfügen`,
's8517ae4da104b004': `Tabellen-Spaltengruppe`,
's85186a61e0d55bac': `Video`,
's851a7deea5984646': `Als Creative Commons OER lizenzieren?`,
's85f9aa6d3ea0e421': `Tabellen-Fußzeilen-Gruppe`,
's864b0e6270e97246': `Auswahl als Nebenkommentar markieren`,
's8670e5ad3bf0dcf8': `Speichern unter`,
's8688d74dd3716d6e': `Tastenkürzel für Befehle`,
's86ca34c5287a2f38': `Wolof`,
's86f820d8007d0de4': `Form-Margen`,
's87cefc710b3567fb': `Eindämmen`,
's88676f992b2965db': `Zellen-Inhalt strecken`,
's886897f2fd4edb99': `Versteckt`,
's886c5db2a5579873': `Konzept`,
's888c71e8fcb916d3': `Automatisch speichern`,
's88a62d29529948fb': `Tabelle einfügen`,
's89950d86c8004d4b': `Überschneiden`,
's89bca7498f20e041': `Hintergrund-Clipping`,
's8a28bad9290d4761': `Oromo`,
's8a29cb39a42f83f3': `Vorher umbrechen`,
's8a4ff2bd9c13498c': `Aufnehmen`,
's8a6585c48ea104e9': `Leere Zellen verstecken`,
's8a9eb438abac7c6a': `Beschriftungen`,
's8b0432eecbd8b034': `Aktualisieren`,
's8b7580c35e2aef87': `Oben links (y)`,
's8bc4affa761aa8a2': `Bild einfügen`,
's8c7f51cb067644c7': `Datenliste`,
's8d342ecaa9e75b9b': `Verhältnis`,
's8d797888455f4147': `Leerzeichen umbrechen`,
's8d83386457e91813': `Änderungen rückgängig machen, wiederholen, oder die Vorschau aus Lernerperspektive aktivieren.`,
's8d8643013a7754d1': `Text anordnen`,
's8df30fe2a50d3479': `Zeilenumbruchs-Gelegenheit einfügen`,
's8e715248c3a78446': `Schneidet die Auswahl aus`,
's8f29e48d6b9a1aa8': `Tabellen-Kopfzeile einfügen`,
's8f4be9f086eb530f': `Rückgängig`,
's8f533296a536965e': `Speichern unter...`,
's8fad58c831ecf017': `Ruby-Text-Container`,
's8ffe7abcbed8eb43': `Vertikal, Links-nach-rechts`,
's90105521fcc40453': `Konten in WebWriter Cloud erlauben es dir, Dokumente online zu speichern und mit deinen Lernenden zu teilen. Fügst du hier ein Konto hinzu, dann ist es als Ort zum Speichern, Laden, Teilen und Öffnen verfügbar.`,
's9095f01a80a91594': `Hochstellung`,
's90f0fbc12e1e2b2f': `Schrift-Palette`,
's90f7c1cf501ea0a7': `Farbe abwedeln`,
's91093e0b087911ba': `Betonungs-Position`,
's919e1724f589c9b1': `Slot`,
's91c5ed7769d00b65': `Einbettung einfügen`,
's9219acd5bef6269e': `Links darunter`,
's92548405912d46bf': `Scroll-Einrast-Anordnung (y)`,
's9258280591309342': `Scroll-Einrast-Anordnung (x)`,
's927d796559f49439': `Hintergrundquelle`,
's92b177e579ef7b97': `Betonung`,
's92f846b9be2e8e8d': `Markiere die Auswahl als kursiv`,
's93566b84230af4f5': `Abbildung einfügen`,
's936aa0b239679585': `Füge einen inhaltlichen Trenner ein (normalerweise eine horizontale Linie)`,
's9370dc6afa716b57': `Rand`,
's93f083e654a45715': `Bretonisch`,
's94653c76b2d86a04': `Definierter Begriff`,
's9485af2e7cd9418f': `Grundschule`,
's94d2eee44b292567': `Fortgeschrittene Optionen umschalten`,
's94d61907ee22a8c1': `Koreanisch`,
's94eb1effbbb6498b': `Überhang`,
's951aa3a6439f1271': `Listen-Symbol`,
's9565553d163fc92a': `Script`,
's957787fc6b7ea5c0': `Schwenken (oben)`,
's95c161f68e5180a5': `Auswahl inspizieren`,
's95d56e58f816d211': `Niederländisch`,
's95d8e41a64635c7c': `Leerraum`,
's95de7e1eff6c053e': `Horizontal, Oben-nach-unten`,
's960d3a90ac199368': `Rätoromanisch`,
's96532132a29dd542': `Audio einfügen`,
's96a045dcade75ad0': `Spalte dicht`,
's9781a5bb3fcb26a3': `Wähle zunächst eine Firma`,
's978522fbc9577a7e': `Somali`,
's97881699a2b21d5b': `Zeilen-Lücke`,
's97aa76056a81bd36': `Metriken`,
's986facb3ecc9602c': `Seitlich, Rechts-nach-links`,
's987abd19fac8cf55': `Tiefstellung`,
's9896529e5cb20558': `Externe Datei`,
's98977a87d1b93941': `Setze Informationen, Styles und Skripte zurück`,
's990d0e0fa2ab00b5': `Galizisch`,
's99229574e5692f19': `Grönländisch`,
's99a990f3841ad283': `Dateien von`,
's99b38e000175cc84': `Durchgestrichen`,
's99f110d27e30b289': `Titel`,
's9ab10fbf4c7a7322': `Unterstreichungs-Position`,
's9abadcc828884d7b': `Textfeld`,
's9b7cd8860c8fc922': str`${0} wird überschrieben. Fortfahren?`,
's9c11f2d9335d8bd1': `Oriya`,
's9c356016f81585f6': `Hintergrundfarbe`,
's9c8df9626d152d5a': `Definitionslisten-Begriff`,
's9ca757effd747da9': `Urdu`,
's9caf10388ab3562f': `Tabellen-Spalte`,
's9cf68f87b8e6122f': `Aserbaidschanisch`,
's9d167ef77aed79b6': `Ebene`,
's9d2d00982edafabb': `Türkisch`,
's9d430adc5be110e9': `Zeile umgekehrt`,
's9d54829be67943d3': `Interlingue`,
's9d54869be6794a9f': `Interlingua`,
's9d668a34af4128ff': `Löschung`,
's9df571714a1efb44': `Eine automatisch gespeicherte Version dieses Explorables ist verfügbar. Laden?`,
's9e28faa598332e2b': `Video einfügen`,
's9e3dbb678150edd4': `Schriftart festlegen`,
's9e40e59654c8ad67': `Spalte`,
's9e85800d3700e31c': `Spur`,
's9e8d3665edde89a6': `Nauruisch`,
's9eefe6e57e4e1661': `Schrift-Variante`,
's9f1ecdb3061d9cbc': `Leerzeichen erhalten`,
's9faf26107ed49fb9': `Tabellen-Zelle einfügen`,
's9fbe26cfd7845469': `Hausa`,
's9fc686f7bbd941e2': `Übergang`,
's9ff3121d30f88d52': `Normal`,
's9ffe1bbe64712bf1': `Zeichenfläche`,
'sa00df4e39c72d3b4': str`${0} wird nicht unterstützt`,
'sa013e119fec906fb': `Zeile`,
'sa01e7bf33563ef72': `Hintergrund-Anheftung`,
'sa126cf8c627cec1e': `Bild-Rendering`,
'sa13f72278add7513': `Rechts darunter`,
'sa1647e3b36ec08d7': `Stehend kombinieren`,
'sa172190ea21f9b1c': `Greif auf die Einstellungen zu, öffne ein Explorable oder erstelle ein neues.`,
'sa1c6c459b9b5115c': `Absolut`,
'sa2cba871f6cdd99f': `Assamesisch`,
'sa2eff4dad1c119f1': `Grid-Vorlage`,
'sa30c12014e955946': `Russisch`,
'sa30f1981fd1cd441': `Schriftgröße`,
'sa311a24c1471a974': `Dokument`,
'sa352d168b262aa06': `Fußzeile einfügen`,
'sa37fee6a52d18063': `Dokument löschen`,
'sa39c7ac1d37f3bce': `Auswahl als bidirektionale Gruppierung markieren`,
'sa3b4c01623211544': `Erzwingen`,
'sa40fd43756fa8913': `Persisch`,
'sa417644bef21a9aa': `Unbenanntes Theme`,
'sa43800e28be1bdbc': `Dekorations-Farbe`,
'sa477cb1825dceb3b': `Sudanesisch`,
'sa492a51a707930fa': `Blockzitat einfügen`,
'sa4e5b39489ecf31a': `isiXhosa`,
'sa4f137f8619093a5': `Beschreibung unten`,
'sa50d3c35533f1d99': `Alle Felder`,
'sa53c5cb03a8fda50': `Auswahl als Snippet in der Palette anheften`,
'sa557ae6bee9148a6': `Fortschrittsanzeige`,
'sa589e1df65dde0ec': `Setze die Größen, Innenabstände und Margen des ausgewählten Elements`,
'sa5c371b4bb75e590': `Links`,
'sa5c80e623459ffe4': `Kopfzeile einfügen`,
'sa5df1bcdba46c3fb': `Abbildungsbeschriftung`,
'sa602e3fd3f2d98fd': `Animation`,
'sa644d580d8a11e60': `Ruby-Anordnugn`,
'sa645d315510dc09e': `Wähle einen Festplatten-Dateipfad`,
'sa65d4ad99f1d8c06': `Text-Hintergrund setzen`,
'sa6607436f60ccc1a': `Estnisch`,
'sa6f8d27bca557059': `Verschiebe meta/link/style-Elemente in dieses Element`,
'sa757645ad842da97': `Umbrüche erhalten`,
'sa75b95980cd80e78': `Editor`,
'sa7698b3d20a6d1ec': `Scrollen`,
'sa778acc33947c7b8': `Einführung beenden`,
'sa78a67272a4a6f95': `Matheformel`,
'sa79167651dce1e80': `Text als Alternative`,
'sa7af797a46c7d09a': `Tabellen-Fußzeile`,
'sa7dbe35b758c138d': `Zeichenfläche einfügen`,
'sa7dc6b8ef3f595dc': `Quelle einfügen`,
'sa8279f8211b3950d': `Umbrüche und Leerzeichen erhalten`,
'sa8b55cab62e439b5': `Spalte entfernen`,
'sa8bbe0197d31b423': `Kurze Beschreibung`,
'sa9ff3b762365abe6': `Transformations-Ursprung (z)`,
'saa02e3762368ff35': `Transformations-Ursprung (y)`,
'saa065776236bfa28': `Transformations-Ursprung (x)`,
'saa33768e03c45fc8': `Dateigröße`,
'saaad98061a20ac39': `Matheformel einfügen`,
'saab875d8cfcfe712': `Theme`,
'saad4380b9cc6cefd': `Abwechselnd darüber`,
'saaec15c97a9e4245': `Spalte umgekehrt`,
'sab0c57df694a0a09': `Anfang zuschneiden`,
'sab4d9283896d9422': `Auflösungs-Pixel einrasten`,
'sab55faae8e165407': `Innenabstand &lt;br&gt; wie Außenabstand`,
'sab5e7d2a069a2951': `Berufsbildung`,
'sab726d2db7e6b93d': `Kirundi`,
'sac687b8649989de8': `Rechts anordnen`,
'sac895c732f350ac5': `Dunkel`,
'saced41ddda8b2354': `Flex-Basis`,
'sad190f86451081c0': `Nepalesisch`,
'sad6be321164d08c8': `Kompaktes Mathe`,
'sadd352cc7f6f2307': `Seitennotiz`,
'sae098810f946ca7c': `Tagalog`,
'sae185e6af80ec81e': `Schwedisch`,
'sae1c7f13b7c0c47f': `Start`,
'sae76e25497dcee58': `Recto`,
'sae9c790b88be7eb9': `Māori`,
'sae9d739068eee2c5': `Tatarisch`,
'saf312eaeec77a802': `Definitionsliste einfügen (Glossar, Begriffsliste)`,
'saf3da7c95cb17260': `Markiere die Auswahl als hochgestellt`,
'saf440a0a592f2835': `Aktualisieren auf`,
'saf9e5134ba1a7d30': `Scroll-Einrasten`,
'safc6f203342d09e2': `Vorschau für das aktive Dokument umschalten`,
'sb0a7e3adf4a125ee': `Oben rechts`,
'sb0a974028c99ca6d': `Adaptionen erlauben?`,
'sb0d4f0f7993cf085': `Schriftgröße festlegen`,
'sb0f3327210fe18fc': `Spalten`,
'sb0f93c1c60c0249a': `Ruby-Basis`,
'sb1494c08c8c720d1': `Textfarbe setzen`,
'sb19611adbc88f711': `Fortgeschritten: Zeige Befehle zum Bearbeiten von Quelltext, z.B. das HTML des Dokuments oder zum Hinzufügen eigener Styles und Skripte.`,
'sb206d700d26b14ff': `Unterstrichen`,
'sb233557012dcb328': `Nach unten verschieben`,
'sb26035b596566abf': `Unbenannt`,
'sb2cda80610c8d6ea': `Alle verteilen`,
'sb2dc787b0983ebc6': `Litauisch`,
'sb31cdff08b1c5a50': `Sindhi`,
'sb38d497d992ab4a4': `Mitte`,
'sb3ba3276ae93627c': `Einen Block vorformatierten Text einfügen`,
'sb430f5b4824de0d3': `Layout wählen`,
'sb43db07b24da018a': `Amharisch`,
'sb45f9fb4dba6e71a': `Ungesetzt`,
'sb4e003a459464d85': `Kurdisch`,
'sb4f0310e6787d098': `Usbekisch`,
'sb4f1dffbb6be6302': `Klärung`,
'sb51270e19988f9bd': `Region`,
'sb59d621e3c93cc27': `Geteilte Zellränder`,
'sb5e9e1776242b028': `Interaktionen`,
'sb60bc1250aad44c1': `Spanne`,
'sb60dd9d23d31ee66': `Promotion`,
'sb6103872073d369e': `Details einfügen`,
'sb616811735bfbafd': `Tabellen-Zelle`,
'sb628960829e223bb': `Überspringen`,
'sb6434faf698b02a2': `Shona`,
'sb657bfe93338dc8b': `Volapük`,
'sb66beca1e766dcb3': `Anwenden und importieren`,
'sb66e2181a7b5738a': `Indem du Telemetrie aktivierst, erlaubst du Datensammlung und -speicherung entsprechend unser`,
'sb67e0e7c0869f982': `Differenz`,
'sb68e83cda6c85af8': `Tabellen-Kopfzeile`,
'sb6b268120592dc53': `Hindi`,
'sb6ca0a8bb3caae69': `Dekorations-Breite`,
'sb70c17f7899f9b01': `Latein`,
'sb71941f552f3504d': `Spezialwert setzen`,
'sb740eab4afd5a710': `Grid-Auto-Fluss`,
'sb741b6e0ca589122': `Zurückfallen (Ebene)`,
'sb7fb7568f6883ab8': `Teile das aktive Dokument`,
'sb85774dc5d18ff0f': `Bestätigen`,
'sb85b1e36579852a6': `Ungültige Email oder Passwort`,
'sb884fa76bfc55429': `Arabisch`,
'sb8a3d4df7d1c5e6b': `Ausgleichen`,
'sb8f610a0e8df91fc': `Leuchtkraft`,
'sb8f855b49234b81b': `Anwenden`,
'sb905da066c10182c': `Plus dunkler`,
'sb940ade1bd81be7e': `Links darunter`,
'sb9e9a7dd45966756': `Markiere die Auswahl als fett`,
'sba509fd8ed61d1d5': `Ungespeicherte Datei`,
'sba64d8954d027206': `Deckkraft`,
'sba88d90cd6c751b3': `Spaltentrenner`,
'sbaf0a7c417e388af': `Gesundheit`,
'sbb15d427ee1aa676': `Tigrinya`,
'sbb34f2e3aa40af4e': `Tongaisch`,
'sbb55f9f2d69fd327': `Hinterebenen-Filter`,
'sbb85a407d730e13d': `Suchbereich einfügen`,
'sbb86c6c96f598bb8': `Gemischt`,
'sbba0156f795d8c07': `Auswahl bearbeiten`,
'sbba865d4b437944f': `Attribut`,
'sbbe639e3a3ed95d1': `NoScript`,
'sbc5bb5bb74d141b9': `Deinstallieren`,
'sbc5f2a81604baf9b': `Überschrift 6`,
'sbc5f2b81604bb14e': `Überschrift 5`,
'sbc5f2c81604bb301': `Überschrift 4`,
'sbc5f2d81604bb4b4': `Überschrift 3`,
'sbc5f2e81604bb667': `Überschrift 2`,
'sbc6953a36ced943f': `Datenschutzrichtlinie`,
'sbd181cd54b8402a4': `Auswahl bearbeiten`,
'sbd35ee879d9cf770': `Ruby-Text`,
'sbd40f40cbadd38d5': `Dieses Paket entfernen`,
'sbd72dc858de95ce8': `Burmesisch`,
'sbe3c60c65f129daa': `Gesellschaftswiss.`,
'sbe4a7c8f231739b3': `oder Datei einfügen/ablegen/wählen`,
'sbe90de083557ef3e': `Swahili`,
'sbefb6064cba01844': `Fügt einen Zeilenumbruch ein`,
'sbf00e1ee999ea94e': `Skript einfügen`,
'sbf519920c2017d67': `Hängend`,
'sbfa01f189a68d3e9': `Flex-Wachsen`,
'sbff54e740c4086eb': `Zeige unbekannte Packages`,
'sbfff51feacf30196': `Sanskrit`,
'sc0ceaa9843510f67': `Turkmenisch`,
'sc1611c0558728a2a': `Position`,
'sc1a155cc25899250': `Tabellen-Zeilen-Gruppe`,
'sc1aa1f6051b7102a': `Rumänisch`,
'sc1edebeaef92b7bd': `Festes Tabellen-Layout`,
'sc1fff4f356dfb2fb': `Transformieren`,
'sc24bda3c061fddf8': `Klickbarer Bereich`,
'sc252a4e091763606': `Tabellen-Fußzeile einfügen`,
'sc2536e077514accc': `Scrollen`,
'sc275dd00036d16cb': `Zitat-Zeichen`,
'sc28864200d2a3799': `QR-Code als Bild kopieren`,
'sc2a24a9dd41a9503': `Dekorations-Linie`,
'sc2b734cca2fa643b': `Schwenken (unten)`,
'sc2e2a0dbf03723b7': `Fortgeschritten: Zeige Packages von unbekannten Heraugebern im Package-Manager (Warnung: Könnte unsicher sein)`,
'sc3998b77d72c2932': `Website einfügen`,
'sc3ac225273c8316b': `Allgemeines`,
'sc3cfee84dbbf36ae': `Lokale Datei`,
'sc3f09a9b6fa4fbed': `Innen`,
'sc43767deea72e9f3': `Definitionsliste`,
'sc462bbdd36bcba6b': `Reference-Box`,
'sc4ee3e4ee994dafd': `Ukrainisch`,
'sc50d09edf9325339': `Dialog`,
'sc52b67794c06a0d3': `Perspektiven-Ursprung (y)`,
'sc52e8b794c0913d6': `Perspektiven-Ursprung (x)`,
'sc53de149fcaad713': `Zwischen Zeichen`,
'sc5bcf50d1b578d9f': `Schrift-Eigenschaften`,
'sc5cb39478b9b7625': `Markiere die Auswahl als tiefgestellt`,
'sc6415b50ff928294': `Listenpunkt`,
'sc650ff15b20fe9d3': `Rotieren (z)`,
'sc6578b15b2154365': `Rotieren (x)`,
'sc65aff15b2183e58': `Rotieren (y)`,
'sc6da0f4a7e4d710e': `Schriftsprachen-Aufhebung`,
'sc74e3567875ce255': `Sowohl der Tag deines Widgets als auch der Name des NPM-Packages`,
'sc7eb080b96e244df': `Malayisch`,
'sc8ac7ef92b95df3f': `Bewegen (x)`,
'sc8af536e2084ade0': `Palette`,
'sc8b022f92b992bc2': `Bewegen (y)`,
'sc8b39af92b9c2d81': `Bewegen (z)`,
'sc8d2c7f6c33a2b32': `Setze den Textstil (Ausrichtung, Einrückung, Leerräume, etc.) of selected elements`,
'sc8fa0e3de389ef1c': `Schriftgrößen-Anpassugn`,
'sc9474bf7a0668d73': `Zusammenfassung`,
'sc94e314312a8900c': `Tschechisch`,
'sc980855a000b76ea': `Unten`,
'sc98b103772de63f4': `Finnisch`,
'sca7cfe2bef51b2a5': `Wurzel`,
'sca7fed2bef53cb99': `Rolle`,
'scabe6ecee5e01fd2': `Maltesisch`,
'scace301a88231cce': `Einbettung`,
'scbc55f622ec078c1': `View-Box`,
'scbe537fc38ff4c13': `Grid-Auto-Spalten`,
'scbf29ce484222325': ``,
'scc1db59d292cbc4c': `Abschnitt`,
'scc56b218a2689c42': `Armenisch`,
'scc5ba32e0de06744': `Sesotho`,
'scd15088c39fe9edf': `Padding Box`,
'scd9cedeb5ece3adb': `Silben trennen`,
'scdf536b65be39ec5': `Neu/Import`,
'sce8a4e3f7c98482d': `Siswati`,
'scec2be75ee985f6c': `Ideographisch`,
'sceecdd0bb404bc17': `Optionsgruppe einfügen`,
'scf00d48fd5953a03': `Griechisch`,
'scf932840a69dbb7c': `Portugiesisch`,
'scf932a8577057752': `Fußzeile`,
'scf95dcb12a950a5c': `Aymara`,
'scfcb70f2a15eaf14': `Unten rechts`,
'sd01178c54f648118': `Spalten ausgleichen`,
'sd03bff50f87f82d4': `Silbentrennungs-Zeichen`,
'sd05a155fe09c2866': `Online beim benutz.`,
'sd0864ea6cb6ef22e': `Community`,
'sd10fdbe6caf9a998': `Zeilenumbruch`,
'sd121d3b959b7888d': `Tempo optimieren`,
'sd1a78e667a1a139f': `Auswahl als Hinzufügung markieren`,
'sd1cffad290ea5b3b': `Alle erhalten`,
'sd1f10284eeb17b25': `Fiji`,
'sd1f44f1a8bc20e67': `Email`,
'sd1f81984eeb7c0e8': `Gefüllt`,
'sd29dc07235eea0f5': `Zitat`,
'sd2addf69477cd4b4': `Paket importieren`,
'sd2ed26defc646d47': `Hinterebenen-Filter`,
'sd2ef82b8ea877c6d': `Afrikaans`,
'sd319aae1401f1e19': `Fest`,
'sd3a288c1094b8a63': `Spaltentrenner-Breite`,
'sd3c65ef5c380c046': `Einsatz`,
'sd3dcb76f7b28adb8': `Lettisch`,
'sd3eca1e0f4209f6e': `Alle zuschneiden`,
'sd3f402df8619ddcd': `Diese Informationen über dich werden automatisch zu neuen Dokumenten hinzugefügt. Du kannst das für jedes Dokument im Metadaten-Editor ändern.`,
'sd4368b12645d3c0f': `Portal einfügen`,
'sd452cebf4a0313d1': `Zeige Quelltext-Befehle`,
'sd48cc52117f4d68b': `Italienisch`,
'sd52660ee947ca58b': `Tabellen-Spalte einfügen`,
'sd588d17a1b25c220': `Text-Überhang`,
'sd5be6f6d85fc0c9b': `Zulu`,
'sd5bf67958b08b4cf': `Höhere Bild.`,
'sd5cf95145e4d89ca': `Schnipsel abheften`,
'sd5fd9d11a92f5b1d': `Unten links (y)`,
'sd60c9bbc51375635': `Knopf einfügen`,
'sd66c4767fa3dde28': `Akzentfarbe`,
'sd679c8b1bf8cc8a5': `Kapitälchen`,
'sd7086c4425c53c80': `Schriftart`,
'sd837f42ac7cbfb58': `Form (außen)`,
'sd88076d2994ee0fb': `Exklusion`,
'sd89a2e529b31ef43': `Zurückfallen`,
'sd8a345e95668b73b': `Vertikal, Rechts-nach-links`,
'sd8ce9e57270b030d': `Schrift-Streckung`,
'sd8ecf227c7c49331': `Mathematisch`,
'sd8f923198e0c5c6a': `Ende`,
'sd9c21e5f60d6bdd8': `Dänisch`,
'sd9ff8e2612e63d50': `Box-Größe mit Rand`,
'sda2d76b976502a8d': `Öffnen...`,
'sda344aacb837387e': `Position im Container`,
'sda5b6fa8b771f996': `Links schwebend`,
'sda9254d1f1228e1a': `Ungarisch`,
'sdb1595f5c742dfbb': `Eingabefeld`,
'sdb711380a28fec75': `Liste einfügen (geordnet)`,
'sdb73788b3c975f16': `Auto`,
'sdbee7e0523a23a42': `Unten rechts (y)`,
'sdc48456f9a27ae02': `Generator`,
'sdc70d81cf6c28533': `Georgisch`,
'sdd1ff479d04ac140': `Öffentlich`,
'sdd2fc8919a9c3111': `Hintergrund-Blend-Modus`,
'sdd35b688281b6dea': `Japanisch`,
'sddc49047f66a64ab': `Keine Beschreibung verfügbar`,
'sdef34fe08bb28b09': `Chinesisch (Vereinfacht)`,
'sdf62e305e1594805': `Auswahl als Ruby-Annotation markieren`,
'sdf946172dfa0328f': `Hochgestellt`,
'sdf9bc5d9b7f3e3de': `Anordnen`,
'se036b53f145441cd': `Gemischter Inhalt`,
'se06f459fccdc3ce9': `Letzte Textzeile anordnen`,
'se0a782a8be8e018b': `Norwegisch`,
'se0cda6b80a1bb50f': `Slovakisch`,
'se0f67eae944f8f94': `Stumm`,
'se1312d6528f9a259': `Yoruba`,
'se16c5e66886fbc59': `Artikel`,
'se1f5bb0386c88f96': `Setze die Farbe des auswählten Texts`,
'se219da7b1e955c65': `Formatierung zurücksetzen`,
'se25e4f2cb77b8be8': `Sprache für das WebWriter-Interface und neue Dokumente`,
'se2796c5824ec8916': `Inhalts-Sichtbarkeit`,
'se308836a594808b6': `Singhalese`,
'se36c5b1baf5e0660': `Irgendwo`,
'se39c065efa467782': `Baskisch`,
'se3b4c857f91f80d7': `Tastenkürzel`,
'se47baf2fd16b9d2b': `Schablone`,
'se48bd9e6c2a3109d': `Konten`,
'se58467472725ad0c': `Bild-Auflösung`,
'se58f06c2b0583ff7': `Koordinaten wählen`,
'se5dc1e97fb743ade': `Abstand`,
'se619a501d1bfe6a5': `Umbrechen`,
'se62385ac082368d2': `Auswahl als Zitatquelle markieren`,
'se6297163cac9d276': `Quelltext bearbeiten`,
'se633223a0b88625e': `Zellen-Platzierung`,
'se638417c560cfe5c': `Innerhalb umbrechen`,
'se64f418b4e733b6c': `Ausgabe einfügen`,
'se6cdad455e2d8c02': `Unterteilung einfügen`,
'se79c0a3ac70d8fb3': `Seitenverh. (x)`,
'se79fae3ac710dc36': `Seitenverh. (y)`,
'se7fad370d8fb4cec': `Lesbarkeit optimieren`,
'se8a94b4effa2033e': `Alphabetisch`,
'se95d4e55ea186d9a': `Scrollbar-Farbe`,
'se96d43a515b8451c': `Slovenisch`,
'se96fd76ba1b2975a': `Zentral`,
'se9ac05f36b004eb0': `Verstecke die Einführung. Deaktivieren, damit die Einführung wieder angezeigt wird.`,
'se9b1fec72ffd8f48': `Lokal`,
'sea24bdcaa2bd2dec': `Einrasten erzwingen`,
'sea52df2b70a5c10d': `Ruby`,
'sea6e7291e27ec53f': `Metadaten-Editor umschalten`,
'sea896ed51ad33287': `Keine spezifischen Styles verfügbar`,
'seaaaeb09e3b4e78b': `Editor-Befehle`,
'seabae79729c4b2ad': `Email-Adresse umschalten`,
'seaecc8267bad6234': `Sekundarstufe I`,
'seaf97719986faf4f': `Lücke`,
'seb19675a580f0628': `Spalte vermeiden`,
'seb4e52ef5ec7a7dc': `Farben/Effekte`,
'seb8982ae8c3cdcc5': `Indonesisch`,
'sebbced89e0db2894': `Erste Grundlinie`,
'sec02109a0dd2a6c8': `Betonungs-Farbe`,
'sec2557a35b702525': `Variable`,
'sec2da4aa7a02b925': `Isländisch`,
'sec30fbb20f102670': `Zusammenfassung einfügen`,
'sec8b0b6c729816b6': `Überschrifts-Gruppe`,
'seccd05955adb76bc': `Poster`,
'sed17285cd25d6389': `Verzeichnis mit package.json`,
'sed318ec045c5144f': `Darüber`,
'sed713f1b916fb469': `Rand-Abstand (x)`,
'sed74a31b9172942c': `Rand-Abstand (y)`,
'sed86bd0deb2e5372': `Text umformen`,
'see2fcaedf9743ec6': `Ort`,
'seec6798afe90ffc8': `Drucken`,
'sef00c258bc1ecf1e': `Es gibt ungesicherte Änderungen`,
'sef23dd271edd4a8b': `Unten links`,
'sef24caccbd4645ef': `Flex-Schrumpfen`,
'sef49aec68fd1dc66': `Name`,
'sef73fe18e351eb35': `Schlagwörter`,
'sef75f458d77491af': `Optionsgruppe`,
'sefcf950b3cc4fc3b': `Sprache`,
'sf0c8e2b013e5ff18': `Dzongkha`,
'sf0ca10f343249063': `Inhalt`,
'sf0cab2483f66aa2e': `Spezifisch`,
'sf0e261e04eda82ff': `Erscheinungsbidl`,
'sf1045382c1fd9a85': `Exakte Druckfarben`,
'sf14c35392ec7bf10': `Diese Funktion ist in Firefox nicht verfügbar. Sie ist in Chrome oder Edge verfügbar.`,
'sf14f9d5f9f6ca342': `Plus heller`,
'sf1868dc19e3917bb': `Spanisch`,
'sf190149f9d8bbb2a': `Schreibart`,
'sf1e79171c4856543': `Bist du sicher? Diese Aktion kann nicht rückgängig gemacht werden, alle Einstellungen werden zurückgesetzt.`,
'sf21c1f60c7515f44': `Auswahl als Ausgabe markieren`,
'sf21fb4f4b9e8911f': `Breite`,
'sf22a3737146ec910': `WebWriter kann SVGs direkt im Dokument einbetten.`,
'sf2514d5dc78b1654': `Widget einfügen`,
'sf28903d4ca0ddcfc': `Entferne dieses Account`,
'sf2ab37af0abc55ef': `Einführung verstecken`,
'sf2bdb0b4d7b9c039': `Bengalisch`,
'sf2cbb5e519264e67': `Horizontal und vertikal skalieren`,
'sf2d5cbc2fe0ad65a': `Angeheftet`,
'sf2d96d0eb32cb81f': `Animations-Zusammensetzung`,
'sf2de3dbe2108637a': `Form-Rendering`,
'sf2e08a945e9194d4': `Walisisch`,
'sf34696c526e810b4': `Inline`,
'sf39736a666dbb038': `Spur einfügen`,
'sf3c4da68b08a2590': `Malagasy`,
'sf471ec2496f904cc': `Änderungen verwerfen`,
'sf4849bc200e279ed': `Tabellen-Beschreibung`,
'sf486ca1fdbe08645': `Abbildung einfügen`,
'sf4b537d4cbd8f5fd': `Text oben`,
'sf4e0e02a5277ef23': `Textfeld einfügen`,
'sf4f067d41efd4b83': `Skalieren (y)`,
'sf4f3cbd41f002b46': `Skalieren (x)`,
'sf4fa67d41f05a008': `Skalieren (z)`,
'sf5197db2d5f2926a': `Rotieren`,
'sf52d840949a980d1': str`${0} wird permanent gelöscht. Fortfahren?`,
'sf55d634dcc743595': `Dienstleist.`,
'sf59c9081d106dd9c': `Auswahl als Variable markieren`,
'sf5e76f774beb33c2': `Inuktitut`,
'sf64a8229a8136552': `Lösche ein Dokument`,
'sf65df67a03bebe4b': `Erforderlich für dieses Widget`,
'sf6673729c03ae999': `WebWriter zurücksetzen`,
'sf67571992e7dc88e': `Voller Begriff`,
'sf6b4934598f7ed10': `Auswahl erlauben`,
'sf6e1665c7022a1f8': `Passwort`,
'sf79e0d78b56444f1': `Inline-Ende`,
'sf7a5f7a7c80c3082': `Beide`,
'sf7c0eba7c822e3d6': `Fett`,
'sf86bd4d2982f3b74': `Markiere die Auswahl als Code`,
'sf8e82313fa411494': `Markiere die Auswahl als Link`,
'sf955eff73fb6b573': `Serbisch`,
'sf9929e2d356260c5': `Multiplizieren`,
'sf993bb199fefbe04': `Alle`,
'sf9ecf969dd4b8164': `Beide Seiten`,
'sf9f2c719a04066ec': `Anwendung`,
'sfa49a5bb1a5d353e': `Privat zugänglich`,
'sfa59c7777e2a0eeb': `Datenliste einfügen`,
'sfaa0a67db5c11f72': `Erste Textzeile einrücken`,
'sfb231a52211b133f': `Kein Textumbruch`,
'sfb68cae41d749423': `Initial`,
'sfb9b6edb0ed378c9': `Zitatquelle`,
'sfbbab09dbe553571': `Füge eine Vektorzeichnung ein (SVG)`,
'sfc00292e778b67e2': `Zähler`,
'sfc63e31ac7c956ed': `Auswahlfeld`,
'sfc815c9078bba30a': `QR-Code als Bild herunterladen`,
'sfcdd8e672c75b713': `Adressbereich`,
'sfcebd18506f1e535': `Fluss`,
'sfd0cde85070d2eb2': `Flex`,
'sfd77270c3f54f664': `Ausgabe`,
'sfdb1e4d90981a535': `Teile dieses Dokument`,
'sfdeef3dccf409f81': `Dieses Keyword is für alle Widgets erforderlich`,
'sfe6e758ad2603c1d': `Master`,
'sfee1c12daf838935': `Farbe einbrennen`,
'sff303daee4dd9f7b': `Lingala`,
'sff3df0c2823ec6e4': `Verso`,
'sff99962304ac7d25': `Dialog einfügen`,
'sffa395f64ec6ac36': `Bulgarisch`,
'sffdadf0a576fd802': `Höhe`,
'spaceKey': `Leertaste`,
'tabKey': `⭾ Tab`,
'upKey': `↑ Hoch`,
    };
  